import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export function MaskedLine({ children, delay = 0, className = "", animate = false }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        {...(animate
          ? { animate: { y: 0 } }
          : { whileInView: { y: 0 }, viewport: { once: true, amount: 0.3 } })}
        transition={{ duration: 1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionHead({ index, kicker, title, accent }) {
  return (
    <div className="mb-8 md:mb-12">
      <MaskedLine>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold mb-4" data-testid={`section-kicker-${index}`}>
          [{index}] — {kicker}
        </p>
      </MaskedLine>
      <MaskedLine delay={0.08}>
        <h2 className="font-display text-3xl sm:text-5xl font-bold uppercase tracking-tight leading-[1.02]">
          {title}{" "}
          {accent && <span className="text-outline-amber">{accent}</span>}
        </h2>
      </MaskedLine>
    </div>
  );
}

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

export function CtaPrimary({ children, onClick, testid, type = "button", disabled = false, className = "" }) {
  return (
    <button
      type={type}
      disabled={disabled}
      data-testid={testid}
      onClick={onClick}
      className={`group relative overflow-hidden border border-gold/60 bg-gold/[0.06] text-gold font-mono text-[11px] uppercase tracking-[0.25em] px-7 py-3.5 transition-colors duration-300 disabled:opacity-40 cursor-pointer ${className}`}
    >
      <span className="absolute inset-0 bg-gold -translate-x-[101%] group-hover:translate-x-0 transition-transform duration-300 ease-out" />
      <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-gold group-hover:w-4 group-hover:h-4 group-hover:border-black transition-all duration-300" />
      <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-gold group-hover:w-4 group-hover:h-4 group-hover:border-black transition-all duration-300" />
      <span className="relative z-10 flex items-center justify-center gap-3 group-hover:text-black transition-colors duration-300">
        {children}
      </span>
    </button>
  );
}

export function CtaGhost({ children, onClick, testid, className = "" }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`group border border-white/15 text-zinc-300 font-mono text-[11px] uppercase tracking-[0.25em] px-7 py-3.5 hover:border-white/40 hover:text-white hover:bg-white/[0.03] transition-colors duration-300 cursor-pointer ${className}`}
    >
      <span className="flex items-center justify-center gap-3">{children}</span>
    </button>
  );
}
